var render, staticRenderFns
import script from "./customPElement.vue?vue&type=script&lang=js&"
export * from "./customPElement.vue?vue&type=script&lang=js&"
import style0 from "./customPElement.vue?vue&type=style&index=0&id=2780a76f&lang=scss&scoped=true&"
import style1 from "./customPElement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780a76f",
  null
  
)

export default component.exports